import React from 'react'
import { EMAILS } from 'shared-constants'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { PureSSRIndicator } from 'components/PureSSRIndicator'
import { H1, Text } from 'components/Typography'
import { ROUTE } from 'constants/routes'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from './utils/prepareGetStaticNavigationProps'

const Support = () => (
  <Flex
    mt={SPACE.PX_80}
    mb={SPACE.PX_120}
    alignItems="center"
    flexDirection="column"
  >
    <H1>Support</H1>
    <Text mb={SPACE.PX_30} textAlign="center">
      You can find our <Link href={ROUTE.FAQ()}>FAQs here</Link> and{' '}
      <Link href={ROUTE.DOCS()}>Docs here</Link>
    </Text>
    <Text textAlign="center">
      Feel free to contact us via email{' '}
      <a href={`mailto:${EMAILS.CUSTOMER_SUPPORT}`}>
        {EMAILS.CUSTOMER_SUPPORT}
      </a>
    </Text>
    <Text my={SPACE.PX_10}>or</Text>
    <Text mb={SPACE.PX_30} textAlign="center">
      if you&#39;re an Expert{' '}
      <a href={`mailto:${EMAILS.EXPERT_SUPPORT}`}>{EMAILS.EXPERT_SUPPORT}</a>
    </Text>
    <Text textAlign="center">
      You can also reach out to us directly on The Expert via live chat bubble.
      We always reply under 24 hours.
    </Text>
    <PureSSRIndicator />
  </Flex>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

Support.getLayout = getPublicLayout

export default Support
